export default __webpack_public_path__ + "76742c941fd85864b2d1dc9a58e05e46.png";